<template>
  <div id="offcanvas" uk-offcanvas="mode: slide; overlay: true;">
    <div class="uk-offcanvas-bar">
      <button class="uk-offcanvas-close" type="button" uk-close></button>
      <div class="uk-panel">
        <ul class="uk-nav uk-nav-default">
          <li class="uk-nav-header">{{ Translations.MenuTitle }}</li>
          <router-link to="/" tag="li" active-class="uk-active" exact>
            <a>{{ Translations.Home }}</a>
          </router-link>
          <router-link to="/offer" tag="li" active-class="uk-active">
            <a>{{ Translations.Offer }}</a>
          </router-link>
          <!--router-link to="/customers" tag="li" active-class="uk-active">
            <a>{{ Translations.Customers }}</a>
          </router-link-->
          <router-link to="/company" tag="li" active-class="uk-active">
            <a>{{ Translations.Company }}</a>
          </router-link>
          <router-link to="/blog" tag="li" active-class="uk-active">
            <a>{{ Translations.Blog }}</a>
          </router-link>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      Translations: {
        MenuTitle: 'Pagina\'s',
        Home: 'Home',
        Offer: 'Aanbod',
        Customers: 'Klanten',
        Company: 'Bedrijf',
        Blog: 'Blog'
      }
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/shared/OffcanvasMenu.vue